module.exports = __webpack_public_path__ + "assets/img/dzh-20.9d0aac36.jpg";